export const STATE = 'state'
export const CITY = 'city'
